<template>
    <div class="deviceInfoModel">
        <transition name="modal">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-container device-info-modal-container">
                        <div class="modal-header">
                            <h5 class="modal-title">
                                <span v-if="device.device_model_id">
                                    ({{device.fitting_number}}) {{deviceModels[device.device_model_id].name}}
                                </span>
                                <span v-else>
                                    {{device.fitting_number}}
                                </span>
                            </h5>
                            <button type="button" class="close" @click="$emit('close')" data-dismiss="modal"
                                    aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <form v-on:submit.prevent>
                                <transition name="fade">
                                    <div class="alert" role="alert"
                                         v-bind:class="{'alert-Success': response.isSuccess, 'alert-danger': response.isFailed}"
                                         v-if="response.done">
                                        <template v-for="msgs in response.message">
                                            <span class="d-block" v-for="msg in msgs">
                                                {{msg}}
                                            </span>
                                        </template>
                                    </div>
                                </transition>
                                <div class="card pl-3 pr-3 pt-3 mt-3 mb-3">
                                    <div class="form-row">
                                        <div class="col-md-12 mb-3">
                                            Device Information
                                            <button class="btn btn-primary ml-3 float-right" @click="confirmPopup()">Locate Device</button>
                                        </div>
                                        <div class="col-md-12 text-center" v-if="pingCommandResponse.isSuccess">
                                            <div class="p-2 mt-2 mb-3 alert-success">
                                                {{pingCommandResponse.message}}
                                            </div>
                                        </div>
                                        <div class="col-md-12 text-center" v-if="pingCommandResponse.isFailed">
                                            <div class="p-2 mt-2 mb-3 alert-danger">
                                                {{pingCommandResponse.message}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <template v-if="deviceModelImageExists">
                                            <div v-bind:class="{'col-md-3': deviceModelImageExists }">
                                                <img :src="returnedUrl()" width="100px" height="100px">
                                            </div>
                                        </template>
                                        <div v-bind:class="{'col-md-9': deviceModelImageExists,'col-md-12' : !deviceModelImageExists }">
                                            <div class="form-row">
                                                <ul class="deviceInfo table-column">
                                                    <li>Activation : <span v-if="device.activation_date">{{getDate('activation_date')}}</span><span
                                                            v-else> Not Available </span></li>
                                                    <li>Warranty Expiration : <span v-if="device.activation_date">{{warrantyDate}}</span>
                                                        <span v-else> Not Available </span></li>

                                                    <li>Last full discharge test result: <span
                                                            v-if="testResult && testResult[0]">{{testStatusList[testResult[0]][0]}}</span><span
                                                            v-else> Not Available </span></li>

                                                    <li>Last full discharge test time : <span v-if="testResult && testResult[1]">{{ humanReadableDate(testResult[1])}} ({{getDate(testResult[1])}})</span>
                                                        <span v-else> Not Available </span></li>

                                                    <li>Last quick test result: <span
                                                            v-if="funcTestResult && funcTestResult[0]">{{testStatusList[funcTestResult[0]][0]}}</span><span
                                                            v-else> Not Available </span></li>

                                                    <li>Last quick test time : <span v-if="funcTestResult && funcTestResult[1]">{{ humanReadableDate(funcTestResult[1])}} ({{getDate(funcTestResult[1])}})</span>
                                                        <span v-else> Not Available </span></li>

                                                    <li>Firmware version : <span v-if="device.firmware_no">{{device.firmware_no}}</span><span
                                                            v-else> Not Available </span></li>
                                                    <li>BLE version :<span v-if="device.ble_version">{{device.ble_version}}</span><span
                                                            v-else> Not Available </span></li>
                                                    <hr>
                                                    <li>
                                                        <p>Last operation:</p>
                                                        <div v-if="device.mac_addr">
                                                            <DeviceAuditLog v-bind:macAddress="device.mac_addr"/>
                                                        </div>
                                                        <div v-else> Not Available </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card p-3 mt-3">
                                    <div class="form-row">
                                        <div class="col-md-3 mb-3">
                                            <label>Fitting No</label>
                                            <input type="text" class="form-control"
                                                   v-model="device.fitting_number">
                                        </div>
                                        <div class="col-md-6 mb-3">
                                            <label>Fitting Type</label>
                                            <select class="form-control" v-model="device.fitting_type">
                                                <option disabled readonly :value="null">Select Fitting Type</option>
                                                <option v-for="fittingType in fittingTypes" :value="fittingType">{{fittingType.name}}</option>
                                            </select>
                                        </div>
                                        <div class="col-md-3 mb-3">
                                            <label>Level</label>
                                            <input type="text" class="form-control"
                                                   v-model="device.level">
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="col-md-12 mb-3">
                                            <label>Location</label>
                                            <input type="text" class="form-control"
                                                   v-model="device.location">
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="col-md-7 mb-3">
                                            <label>IP Address</label>
                                            <input type="text" class="form-control" disabled readonly
                                                   v-model="device.ip_addr">
                                        </div>
                                        <div class="col-md-5 mb-3">
                                            <label>Mac Address</label>
                                            <input type="text" class="form-control" disabled readonly
                                                   v-model="device.mac_addr">
                                        </div>
                                    </div>
                                    <button class="btn btn-primary" type="button" @click="update()"
                                            :disabled="disabled">
                                        <span v-if="disabled" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">Updating ... </span>
                                        <span v-else>Update</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <ModalComponent v-if="dataToPassToConfirmModal.showModal"
                @close="dataToPassToConfirmModal.showModal = false"
                @execute="sendBlinkCommand"
                :dataToPassToModal="dataToPassToConfirmModal"
                :confirm="confirm">
        </ModalComponent>
    </div>
</template>
<script>
  import ConnectionService from '../../app-model/model';
  import Tools from '../../app-model/tools'
  import ModalComponent from '../../components/modal/ModalComponent';
  import DeviceAuditLog from "@/components/audit/DeviceAuditLog";
  const connectionService = new ConnectionService();

  export default {
    data () {
      return {
        confirm: {
          title: '',
          msg: ''
        },
        dataToPassToConfirmModal: {
          showModal: false,
        },
        response: {
          isSuccess: false,
          isFailed: false,
          message: '',
          done: false
        },

        pingCommandResponse :{
          isSuccess: false,
          isFailed: false,
          message: '',
          done: false
        },

        deviceModelFiles: [],
        deviceModel: '',
        deviceModelImageExists:false,
        savedDevice: undefined,
        disabled: false,
        device: {
          device_model: {},
          fitting_type: {
            id: null
          }
        },
      }
    },
    components:{
      DeviceAuditLog,
      ModalComponent
    },
    props: {
      deviceModels: Object,
      dataToPassToModal: Object,
      fittingTypes: Array,
      testResult: Array,
      funcTestResult: Array,
      testStatusList: Object,
    },
    async created () {
      await this.$store.dispatch('apiResult', {
        method: 'GET',
        path: `api/user-buildings/${this.dataToPassToModal.buildingId}/devices/${this.dataToPassToModal.deviceId}`,
        path_template: '/api/user-buildings/{building_id}/devices/{device_id}',
        building_id: this.dataToPassToModal.buildingId
      }).then(response => {
        switch (response.status) {
          case 200 :
            this.device = response.data.data;
            break;
        }
        return response;
      }).then(response => this.getDeviceModelImage());
    },
    methods: {
      confirmPopup () {
        this.dataToPassToConfirmModal.showModal = true
        this.confirm.title = `Confirm Blink`;
        this.confirm.msg = `The emergency light will blink for 15 seconds and it may cause disruption. This function may not work depending on the network status. Are you sure to proceed?`;
      },
      sendBlinkCommand:function () {
        this.dataToPassToConfirmModal.showModal = false
        this.$store.dispatch('apiResult', {
          method: 'POST',
          path: `api/user-buildings/${this.dataToPassToModal.buildingId}/devices-commands/${this.dataToPassToModal.deviceId}/blink`,
          path_template: '/api/user-buildings/{building_id}/devices-commands/{device_id}/blink',
          building_id: this.dataToPassToModal.buildingId
        }).then(response => {
          switch (response.status) {
            case 200:
              this.pingCommandResponse.isSuccess = true;
              this.pingCommandResponse.isFailed = false;
              this.pingCommandResponse.message = response.data.message;
              break;

            case 422:
              this.pingCommandResponse.isSuccess = false;
              this.pingCommandResponse.isFailed = true;
              this.pingCommandResponse.message = response.data.message;
              break
          }
        })
      },

      returnedUrl () {
        this.deviceModel = this.deviceModelFiles[0]
        return `${this.deviceModel.file.path}?token=${encodeURI(this.deviceModel.file.token)}`
      },
      getDeviceModelImage:function () {
        if (!this.device.device_model_id) {
          return;
        }
        this.$store.dispatch('apiResult', {
          method: 'GET',
          path: `api/device-models/${this.device.device_model_id}/files`,
          path_template: '/api/device-models/{device_model_id}/files',
          building_id: this.dataToPassToModal.buildingId
        }).then(response => {
          switch (response.status) {
            case 200:
              this.deviceModelFiles = response.data.data.files
              this.deviceModel = this.deviceModelFiles[0]
              this.deviceModelImageExists = true
              break
            case 410:
              this.deviceModelImageExists = false
              break
          }
        })
      },
      update: function () {
        let data = (({fitting_number, sub_building_name, level, location, fitting_type}) => {
          return {fitting_number, sub_building_name, level, location, fitting_type_id: fitting_type ? fitting_type.id: undefined};
        })(this.device);

        this.disabled = true;

        this.$store.dispatch('apiResult', {
          method: 'PATCH',
          path: `api/user-buildings/${this.dataToPassToModal.buildingId}/devices/${this.device.id}`,
          data: data,
          path_template: '/api/user-buildings/{building_id}/devices/{device_id}',
          building_id: this.dataToPassToModal.buildingId
        }).then(response => {
          this.disabled = false;

          switch (response.status) {
            case 200 :
              this.savedDevice = (({id, fitting_number, sub_building_name, level, location, fitting_type}) => {
                return {id, data: {fitting_number, sub_building_name, level, location, fitting_type}};
              })(this.device);
              this.response.isSuccess = true;
              this.response.isFailed = false;
              this.response.message = [['Device Updated']];

              this.$emit('update', this.savedDevice);
              this.$emit('close');
              break;
            default:
              this.response.isSuccess = false;
              this.response.isFailed = true;
              this.response.message = response.data;
              break;
          }

          return response;
        });
      },
      getDate (ts) {
        return this.tools.formatDateWithFullYear(new Date(ts * 1000))
      },

      humanReadableDate(ts) {
        return this.tools.humanizedTimeSpan(new Date(ts * 1000), new Date())
      },

    },
    computed:{
      tools: function () {
        return new Tools
      },
      warrantyDate() {
        let activationDate = new Date(this.device.activation_date * 1000)
        activationDate.setDate((activationDate.getDate() + this.device.warranty))

        return this.tools.formatDateWithFullYear(new Date(activationDate))
      },
    }
  }
</script>